import { useEffect, useRef } from 'react';

function useTimeout(fn, delay) {
  var timerRef = useRef();
  timerRef.current = fn;
  useEffect(function () {
    if (typeof delay !== 'number') {
      return;
    }

    var timer = setTimeout(function () {
      var _a;

      (_a = timerRef.current) === null || _a === void 0 ? void 0 : _a.call(timerRef);
    }, delay);
    return function () {
      clearTimeout(timer);
    };
  }, [delay]);
}

export default useTimeout;